var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "well p-4" }, [
    _c("div", { staticClass: "flex-level flex-top" }, [
      _c("div", { staticClass: "wp-5" }, [
        _c("section", { staticClass: "mb-4" }, [
          _c("h3", { staticClass: "mt-0 mb-2 lh-24 fs-4 bold" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Informations")))
          ]),
          _vm._v(" "),
          _c(
            "article",
            { staticClass: "mb-3" },
            [
              _c(
                "CompassFormItem",
                {
                  attrs: {
                    label: _vm.$t.__("common.labels.currency"),
                    error: _vm.errors.get("currency_id")
                  }
                },
                [
                  _c(
                    "CompassSelect",
                    {
                      staticClass: "input-half",
                      class: { "select-error": _vm.errors.has("currency_id") },
                      model: {
                        value: _vm.form.currency,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "currency", $$v)
                        },
                        expression: "form.currency"
                      }
                    },
                    _vm._l(_vm.currencies, function(currency) {
                      return _c("CompassDropdownSelectOption", {
                        key: currency.id,
                        attrs: {
                          label: currency.symbol,
                          value: +currency.id,
                          disabled: currency.enabled !== "Y"
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "article",
            { staticClass: "mb-3" },
            [
              _c(
                "CompassFormItem",
                {
                  attrs: {
                    label: _vm.$t.__(
                      "overview.tabs.actions.EditPreferencesThird.carrier"
                    ),
                    error: _vm.errors.get("carrier_id")
                  }
                },
                [
                  _c(
                    "CompassSelect",
                    {
                      staticClass: "input-half",
                      class: { "select-error": _vm.errors.has("carrier_id") },
                      model: {
                        value: _vm.form.shipper,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shipper", $$v)
                        },
                        expression: "form.shipper"
                      }
                    },
                    _vm._l(_vm.metadata.shippers, function(shipper) {
                      return _c("CompassDropdownSelectOption", {
                        key: shipper.value,
                        attrs: { label: shipper.label, value: shipper.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "article",
            { staticClass: "mb-3" },
            [
              _c(
                "CompassFormItem",
                {
                  attrs: {
                    label: _vm.$t.__(
                      "overview.tabs.actions.EditPreferencesThird.default_VAT"
                    ),
                    error: _vm.errors.get("tax_id")
                  }
                },
                [
                  _c(
                    "CompassSelect",
                    {
                      staticClass: "wp-10",
                      class: { "select-error": _vm.errors.has("tax_id") },
                      model: {
                        value: _vm.form.tax,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "tax", $$v)
                        },
                        expression: "form.tax"
                      }
                    },
                    _vm._l(_vm.taxes, function(tax) {
                      return _c("CompassDropdownSelectOption", {
                        key: tax.id,
                        attrs: {
                          label: _vm._f("taxeLabel")(tax),
                          value: tax.id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "article",
            { staticClass: "mb-3" },
            [
              _c(
                "CompassFormItem",
                {
                  attrs: {
                    label: _vm.$t.__(
                      "overview.tabs.actions.EditPreferencesThird.payment_term"
                    ),
                    error: _vm.errors.get("paymentTerm.xdays")
                  }
                },
                [
                  _c(
                    "CompassSelect",
                    {
                      staticClass: "input-half",
                      class: {
                        "select-error": _vm.errors.has("payment_terms_id")
                      },
                      on: { change: _vm.clearEndOfMonth },
                      model: {
                        value: _vm.form.paymentTerm.id,
                        callback: function($$v) {
                          _vm.$set(_vm.form.paymentTerm, "id", $$v)
                        },
                        expression: "form.paymentTerm.id"
                      }
                    },
                    _vm._l(_vm.metadata.paymentTerms, function(paymentTerm) {
                      return _c("CompassDropdownSelectOption", {
                        key: paymentTerm.value,
                        attrs: {
                          label: paymentTerm.label,
                          value: paymentTerm.value
                        }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.enableEndOfMonthBox
                    ? _c("CompassCheckbox", {
                        staticClass: "mt-3",
                        attrs: {
                          "model-value": _vm.$t.__(
                            "overview.tabs.actions.EditPreferencesThird.end_month"
                          ),
                          checked: _vm.form.paymentTerm.endOfMonth
                        },
                        on: { change: _vm.checkEndOfMonth }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.enableXDays
                    ? _c("CompassInput", {
                        staticClass: "mt-3 input-half",
                        attrs: {
                          error: _vm.errors.has("paymentTerm.xdays"),
                          placeholder: _vm.$t.__(
                            "overview.tabs.actions.EditPreferencesThird.enter_day_number"
                          )
                        },
                        model: {
                          value: _vm.form.paymentTerm.xdays,
                          callback: function($$v) {
                            _vm.$set(_vm.form.paymentTerm, "xdays", $$v)
                          },
                          expression: "form.paymentTerm.xdays"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "article",
            { staticClass: "mb-3" },
            [
              _c(
                "CompassFormItem",
                {
                  attrs: {
                    label: _vm.$t.__(
                      "overview.tabs.actions.EditPreferencesThird.global_discount"
                    )
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "amount-group" },
                    [
                      _c("InputWithSelect", {
                        attrs: {
                          options: [
                            { label: "€", value: "amount" },
                            { label: "%", value: "percent" }
                          ]
                        },
                        model: {
                          value: _vm.form.discount,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "discount", $$v)
                          },
                          expression: "form.discount"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "article",
            [
              !!_vm.metadata.bankAccounts.length
                ? _c(
                    "CompassFormItem",
                    {
                      attrs: {
                        label: _vm.$t.__(
                          "overview.tabs.actions.EditPreferencesThird.bank_account"
                        ),
                        error: _vm.errors.get("bank_account_id")
                      }
                    },
                    [
                      _c(
                        "CompassSelect",
                        {
                          class: {
                            "select-error": _vm.errors.has("bank_account_id")
                          },
                          model: {
                            value: _vm.form.bankAccount,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "bankAccount", $$v)
                            },
                            expression: "form.bankAccount"
                          }
                        },
                        _vm._l(_vm.metadata.bankAccounts, function(account) {
                          return _c("CompassDropdownSelectOption", {
                            key: account.value,
                            attrs: {
                              label: account.label,
                              value: account.value
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("CompassCheckbox", {
                staticClass: "mt-3",
                attrs: {
                  "model-value": _vm.$t.__(
                    "overview.tabs.actions.EditPreferencesThird.each_line"
                  ),
                  size: "medium",
                  checked: _vm.form.discountByRow
                },
                on: {
                  change: function(val) {
                    return (_vm.form.discountByRow = val)
                  }
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        !_vm.isSupplier && Object.keys(_vm.metadata.dunning).length
          ? _c("section", [
              _c("h3", { staticClass: "mt-0 mb-2 lh-24 fs-4 bold" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$l10n.__("Plan de relance")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _vm.metadata.dunning.estimate
                ? _c(
                    "article",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "CompassFormItem",
                        {
                          attrs: {
                            label: _vm.$t.__(
                              "overview.tabs.actions.EditPreferencesThird.estimate_plan"
                            ),
                            error: ""
                          }
                        },
                        [
                          _c(
                            "CompassSelect",
                            {
                              model: {
                                value: _vm.form.dunning.estimate.value,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.dunning.estimate,
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "form.dunning.estimate.value"
                              }
                            },
                            _vm._l(_vm.metadata.dunning.estimate, function(
                              planEstimate
                            ) {
                              return _c("CompassDropdownSelectOption", {
                                key: planEstimate.id,
                                attrs: {
                                  label: planEstimate.label,
                                  value: planEstimate.value
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.metadata.dunning.invoice
                ? _c(
                    "article",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "CompassFormItem",
                        {
                          attrs: {
                            label: _vm.$t.__(
                              "overview.tabs.actions.EditPreferencesThird.invoice_plan"
                            ),
                            error: ""
                          }
                        },
                        [
                          _c(
                            "CompassSelect",
                            {
                              model: {
                                value: _vm.form.dunning.invoice.value,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.dunning.invoice,
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "form.dunning.invoice.value"
                              }
                            },
                            _vm._l(_vm.metadata.dunning.invoice, function(
                              planEstimate
                            ) {
                              return _c("CompassDropdownSelectOption", {
                                key: planEstimate.id,
                                attrs: {
                                  label: planEstimate.label,
                                  value: planEstimate.value
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.metadata.dunning.proforma
                ? _c(
                    "article",
                    [
                      _c(
                        "CompassFormItem",
                        {
                          attrs: {
                            label: _vm.$t.__(
                              "overview.tabs.actions.EditPreferencesThird.proforma_plan"
                            ),
                            error: ""
                          }
                        },
                        [
                          _c(
                            "CompassSelect",
                            {
                              model: {
                                value: _vm.form.dunning.proforma.value,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.dunning.proforma,
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "form.dunning.proforma.value"
                              }
                            },
                            _vm._l(_vm.metadata.dunning.proforma, function(
                              planEstimate
                            ) {
                              return _c("CompassDropdownSelectOption", {
                                key: planEstimate.id,
                                attrs: {
                                  label: planEstimate.label,
                                  value: planEstimate.value
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wp-5" }, [
        _c("section", [
          !_vm.isSupplier
            ? _c(
                "article",
                { staticClass: "mb-3" },
                [
                  _c(
                    "CompassFormItem",
                    {
                      attrs: {
                        label: _vm.$t.__(
                          "overview.tabs.actions.EditPreferencesThird.price_category"
                        ),
                        error: _vm.errors.get("rateCategory")
                      }
                    },
                    [
                      _c(
                        "CompassSelect",
                        {
                          class: {
                            "select-error":
                              _vm.errors.has("rateCategory") ||
                              _vm.errors.has("rate_category_id")
                          },
                          model: {
                            value: _vm.form.rateCategory,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "rateCategory", $$v)
                            },
                            expression: "form.rateCategory"
                          }
                        },
                        _vm._l(_vm.metadata.rateCategories, function(
                          rateCategory
                        ) {
                          return _c("CompassDropdownSelectOption", {
                            key: rateCategory.value,
                            attrs: {
                              label: rateCategory.label,
                              value: rateCategory.value
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "article",
            [
              _c(
                "CompassCheckboxGroup",
                {
                  attrs: {
                    label: _vm.$t.__(
                      "overview.tabs.actions.EditPreferencesThird.payment_method"
                    )
                  }
                },
                _vm._l(_vm.metadata.payMediums, function(medium) {
                  return _c("CompassCheckbox", {
                    key: medium.value,
                    attrs: {
                      "model-value": medium.label,
                      checked: _vm.mediumState(medium.value)
                    },
                    on: {
                      change: function(e) {
                        return _vm.setMedium(e, medium.value)
                      }
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex-level flex-end mt-4" },
      [
        _c("CompassButton", {
          attrs: {
            label: _vm.$t.__("common.actions.cancel"),
            type: "secondary"
          },
          on: { click: _vm.close }
        }),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: {
            label: _vm.$t.__("common.actions.save"),
            loading: _vm.loading,
            type: "primary"
          },
          on: { click: _vm.save }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }